import React from 'react'
import { makeStyles } from '@mui/styles';
import { Paper } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import { styled, useTheme, Theme, CSSObject } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { createTheme } from '@mui/material/styles';
const theme = createTheme();
const useStyles = makeStyles({
    toolbar: {
        alignItems: "center",
        justifyContent: "flex-end",
        padding: theme.spacing(0, 1),
        ...theme.mixins.toolbar,
    },
    paper: {
        marginTop: "2rem",
        width: "100%",
    },
    tableHeadCell: {
        color: "#fff",
        fontWeight: "bold",
        textAlign: "center",
    },
    tableContainer: {
        marginTop: "2rem",
        position: "sticky",
        top: "200px",
    },
    table: {
        maxWidth: "100%",
    },
    tableHead: {
        background: "rgb(146, 74, 145)!important",
    },
})

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: "#07639d",
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));
interface Props {

}

const BookingTable: React.FC<Props> = ({

}) => {
    const classes = useStyles();
    return (
        <div style={{ width: "100%" }} className="data-table">
            <TableContainer className={classes.tableContainer}
                component={Paper}
                style={{ maxHeight: "550px" }}
            >
                <Table stickyHeader aria-label="simple table">
                    <TableHead className={classes.tableHead}>
                        <StyledTableRow>
                            <StyledTableCell className={classes.tableHeadCell}>Action</StyledTableCell>
                            <StyledTableCell className={classes.tableHeadCell}>Booking Id</StyledTableCell>
                            <StyledTableCell className={classes.tableHeadCell}>Lead ID</StyledTableCell>
                            <StyledTableCell className={classes.tableHeadCell}> Name</StyledTableCell>
                            <StyledTableCell className={classes.tableHeadCell}>Age</StyledTableCell>
                            <StyledTableCell className={classes.tableHeadCell}>Gender</StyledTableCell>
                            <StyledTableCell className={classes.tableHeadCell}>Mobile Number</StyledTableCell>
                            <StyledTableCell className={classes.tableHeadCell}>Booking Date</StyledTableCell>
                            <StyledTableCell className={classes.tableHeadCell}>Collection Date</StyledTableCell>
                            <StyledTableCell className={classes.tableHeadCell}>Collection Time</StyledTableCell>
                            <StyledTableCell className={classes.tableHeadCell}>Booking Status</StyledTableCell>
                            <StyledTableCell className={classes.tableHeadCell}>Pickup Status</StyledTableCell>
                            <StyledTableCell className={classes.tableHeadCell}>Report Status</StyledTableCell>
                        </StyledTableRow>
                    </TableHead>
                    <TableBody>
                    <StyledTableRow>
                    <StyledTableCell align="center">Edit</StyledTableCell>
                    <StyledTableCell align="center">52698364</StyledTableCell>
                    <StyledTableCell align="center">27378945</StyledTableCell>
                    <StyledTableCell align="center">ABCDEF</StyledTableCell>
                    <StyledTableCell align="center">22</StyledTableCell>
                    <StyledTableCell align="center">FEMAIL</StyledTableCell>
                    <StyledTableCell align="center">896237475</StyledTableCell>
                    <StyledTableCell align="center">02-02-2023</StyledTableCell>
                    <StyledTableCell align="center">02-02-2023</StyledTableCell>
                    <StyledTableCell align="center">02-02-2023</StyledTableCell>
                    <StyledTableCell align="center">PENDING</StyledTableCell>
                    <StyledTableCell align="center">PENDING</StyledTableCell>
                    <StyledTableCell align="center">PENDING</StyledTableCell>
                    </StyledTableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    )
}

export default BookingTable